import React, { Fragment, useState } from 'react'
import { turboRequest } from '../../../../helpers/turbo_helper'
import PersonTypeaheadInput from 'components/PersonTypeaheadInput'
import './style.scss'

const SelectPerson = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })

  const onChange = selected => {
    setState(() => ({ ...props, selected: selected ? selected.label : null }))

    if (selected && !state.ignoreNewRole) {
      var url = `/admin/org/people/${selected.value}/new_role?role=${state.role}`

      if (state.url) {
        url = new URL(state.url)
        var urlParams = new URLSearchParams(url.search)
        urlParams.append('person_id', selected.value)
      }

      turboRequest(state.url ? `${url.pathname}?${urlParams}` : url)
    }
  }

  const onInputChange = name => {
    setState(() => ({ ...props, name: name, selected: null }))
  }

  return (
    <Fragment>
      <div className='input required' id='select_person_input'>
        <div className='org-typeahead typeahead-select-person'>
          <PersonTypeaheadInput {...state} filterBy={['email']} id={state.id} onChange={onChange} onInputChange={onInputChange} />
          <input id='hiddenName' type='hidden' value={state.name || state.selected || ''} name='name' />
        </div>
      </div>
    </Fragment>
  )
}

export default SelectPerson
